import { Tooltip } from '@zillow/constellation';
import { Paragraph } from '@zillow/constellation';
import { TooltipPopper } from '@zillow/constellation';
import React from 'react';
import { DateFormat, getDateString } from 'ui-toolkit/utilities/getDateString';

interface IVoidDisplayProps {
  item: {
    voidedAt?: string;
    voidedBy?: string;
    voidReason?: string;
    voidReasonDescription?: string;
  };
  prettyVoidReason?: string;
}

export const VoidDisplay: React.FC<IVoidDisplayProps> = ({ item, prettyVoidReason }) => {
  if (!item.voidedAt) {
    return null;
  }
  return (
    <>
      {getDateString(DateFormat.hugeDate, item.voidedAt, true)}
      <TooltipPopper
        mouseEnterDelay={0}
        triggered={
          <Tooltip
            body={
              <>
                <Paragraph>
                  <strong>Voided At:</strong> {getDateString(DateFormat.hugeDateTime, item.voidedAt, true)}
                </Paragraph>
                <Paragraph>
                  <strong>Voided By:</strong> {item.voidedBy}
                </Paragraph>
                <Paragraph>
                  <strong>Void Reason:</strong> {prettyVoidReason ?? item.voidReason}
                  {item.voidReasonDescription && <>- {item.voidReasonDescription}</>}
                </Paragraph>
              </>
            }
          />
        }
      />
    </>
  );
};
